import React from 'react';
import {
  BaseMixin,
  ElementaryMixin,
  NestingLevelMixin,
  ColorSchemaMixin,
  ContentMixin,
  Tools
} from '../common/common.js';
import Environment from '../environment/environment.js';
import Panel from './panel.js';

import './accordion.less';

export const Accordion = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin,
    ColorSchemaMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Accordion',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection','box'),
    classNames: {
      main: 'uu5-bricks-accordion panel-group'
    },
    defaults: {
      childTagName: 'UU5.Bricks.Panel'
    },
    warnings: {
      unsupportedType: 'Type %s of parameter %s is not supported. Allowed types are: %s.'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    panels: React.PropTypes.arrayOf(React.PropTypes.object),
    onClickNotCollapseOthers: React.PropTypes.bool,
    glyphiconExpanded: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.object
    ]),
    glyphiconCollapsed: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.object
    ]),
    onClick: React.PropTypes.func,
    allowTags: React.PropTypes.arrayOf(
      React.PropTypes.string
    )
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      panels: null,
      glyphiconExpanded: null,
      glyphiconCollapsed: null,
      onClickNotCollapseOthers: false,
      onClick: null,
      allowTags: []
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  getPanelById: function (panelId) {
    return this.getRenderedChildById(panelId);
  },

  getPanelByName: function (panelName) {
    return this.getRenderedChildByName(panelName);
  },

  getPanels: function () {
    return this.getRenderedChildren();
  },

  eachPanel: function (callback) {
    var panels = this.getPanels();
    for (var i = 0; i < panels.length; i++) {
      var result = callback(panels[i], i);
      if (result === false) {
        break;
      }
    }
    return this;
  },

  eachPanelByIds: function (ids, callback) {
    for (var i = 0; i < ids.length; i++) {
      var result = callback(this.getPanelById(ids[i]), i);
      if (result === false) {
        break;
      }
    }
    return this;
  },

  eachPanelByNames: function (names, callback) {
    for (var i = 0; i < names.length; i++) {
      var result = callback(this.getPanelByName(names[i]), i);
      if (result === false) {
        break;
      }
    }
    return this;
  },

  expandPanelById: function (panelId, setStateCallback) {
    this._eachPanelByIdWithCallback(panelId, setStateCallback, function (panel, i, newSetStateCallback) {
      panel.expand(newSetStateCallback);
    });
    return this;
  },

  expandPanelByName: function (panelName, setStateCallback) {
    this._eachPanelByNameWithCallback(panelName, setStateCallback, function (panel, i, newSetStateCallback) {
      panel.expand(newSetStateCallback);
    });
    return this;
  },

  collapsePanelById: function (panelId, setStateCallback) {
    this._eachPanelByIdWithCallback(panelId, setStateCallback, function (panel, i, newSetStateCallback) {
      panel.collapse(newSetStateCallback);
    });
    return this;
  },

  collapsePanelByName: function (panelName, setStateCallback) {
    this._eachPanelByNameWithCallback(panelName, setStateCallback, function (panel, i, newSetStateCallback) {
      panel.collapse(newSetStateCallback);
    });
    return this;
  },

  togglePanelById: function (panelId, setStateCallback) {
    this._eachPanelByIdWithCallback(panelId, setStateCallback, function (panel, i, newSetStateCallback) {
      panel.toggle(newSetStateCallback);
    });
    return this;
  },

  togglePanelByName: function (panelName, setStateCallback) {
    this._eachPanelByNameWithCallback(panelName, setStateCallback, function (panel, i, newSetStateCallback) {
      panel.toggle(newSetStateCallback);
    });
    return this;
  },

  expandAll: function (setStateCallback) {
    this._eachPanelWithCallback(setStateCallback, function (panel, i, newSetStateCallback) {
      panel.expand(newSetStateCallback);
    });
    return this;
  },

  collapseAll: function (setStateCallback) {
    this._eachPanelWithCallback(setStateCallback, function (panel, i, newSetStateCallback) {
      panel.collapse(newSetStateCallback);
    });
    return this;
  },

  toggleAll: function (setStateCallback) {
    this._eachPanelWithCallback(setStateCallback, function (panel, i, newSetStateCallback) {
      panel.toggle(newSetStateCallback);
    });
    return this;
  },

  shouldCollapseOthers: function () {
    return !this.props.onClickNotCollapseOthers;
  },

  collapseOthers: function (panelId, setStateCallback) {
    var panels = this.getPanels();

    var counter = 0;
    panels.forEach(function (panel) {
      panel.getId() !== panelId && panel.isExpandable() && counter++;
    });

    var newSetStateCallback = Tools.buildCounterCallback(setStateCallback, counter);

    panels.forEach(function (panel) {
      panel.getId() !== panelId && panel.isExpandable() && panel.collapse(newSetStateCallback);
    });

    return this;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  shouldChildRender_: function (child) {
    var childTagName = Tools.getChildTagName(child);
    var childTagNames = this.props.allowTags.concat(this.getDefault().childTagName);
    return childTagNames.indexOf(childTagName) > -1;
  },

  expandChildProps_: function (child, i) {
    var newChildProps = Tools.mergeDeep({}, child.props);
    var onClick = newChildProps.onClick || this.props.onClick;

    newChildProps.onClick = this.shouldCollapseOthers() ? (panel) => {
        (panel && panel.isExpanded()) ? this.collapseOthers(panel.getId(), () => onClick && onClick(panel)) : child.props.onClick ? child.props.onClick(panel) : this.props.onClick ? this.props.onClick(panel) : null
      } : child.props.onClick || this.props.onClick;
    newChildProps.glyphiconExpanded = newChildProps.glyphiconExpanded || this.props.glyphiconExpanded;
    newChildProps.glyphiconCollapsed = newChildProps.glyphiconCollapsed || this.props.glyphiconCollapsed;
    newChildProps.colorSchema = newChildProps.colorSchema || this.props.colorSchema;

    return newChildProps;
  },
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getValuesAsArray: function (value, name) {
    var values = [];

    if (typeof value === 'string') {
      values = [value];
    } else if (Array.isArray(value)) {
      values = value;
    } else {
      this.showWarning('unsupportedType', [typeof value, name, 'string, array']);
    }

    return values
  },

  _eachPanelWithCallback: function (setStateCallback, callback) {
    var panels = this.getPanels();
    var newSetStateCallback = Tools.buildCounterCallback(setStateCallback, panels.length);

    for (var i = 0; i < panels.length; i++) {
      var result = callback(panels[i], i, newSetStateCallback);
      if (result === false) {
        break;
      }
    }

    return this;
  },

  _eachPanelByIdWithCallback: function (panelId, setStateCallback, callback) {
    var ids = this._getValuesAsArray(panelId, 'panelId');
    var newSetStateCallback = Tools.buildCounterCallback(setStateCallback, ids.length);

    this.eachPanelByIds(ids, function (panel, i) {
      return callback(panel, i, newSetStateCallback);
    });

    return this;
  },

  _eachPanelByNameWithCallback: function (panelName, setStateCallback, callback) {
    var names = this._getValuesAsArray(panelName, 'panelName');
    var newSetStateCallback = Tools.buildCounterCallback(setStateCallback, names.length);

    this.eachPanelByNames(names, function (panel, i) {
      return callback(panel, i, newSetStateCallback);
    });

    return this;
  },
  //@@viewOff:componentSpecificHelpers

  //Render
  _buildChildren: function () {
    var childrenProps = {};
    if (this.props.panels) {
      childrenProps.content = {tag: this.getDefault().childTagName, propsArray: this.props.panels};
    } else if (this.props.children) {
      childrenProps.children = this.props.children;
    } else {
      childrenProps.content = <Panel />;
    }

    return this.buildChildren(childrenProps);
  },

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <div {...this.buildMainAttrs()}>
            {this._buildChildren()}
            {this.getDisabledCover()}
          </div>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Accordion;



// WEBPACK FOOTER //
// ./bricks/accordion.js